import { ReactElement, PropsWithChildren, useState } from "react";
import { className } from "../../../../shared/helpers";
import styles from "./FiltersWrapper.module.scss";

const FiltersWrapper = (props: PropsWithChildren<{}>): ReactElement =>
{
    const [displayFilters, setDisplayFilters] = useState<boolean>(false);

    return (
        <div {...className(styles.filtersWrapper, { [styles.filtersVisible]: displayFilters })}>
            <button className={styles.mobileToggler} onClick={() => setDisplayFilters(!displayFilters)}>
                <span>Filters</span>
                <i className="material-icons">{displayFilters ? "close" : "filter_alt"}</i>
            </button>

            <div className={styles.filters}>{props.children}</div>
        </div>
    );
};

export default FiltersWrapper;
